import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import Asa from './asa'
import Spirit from './spirit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { request } from '../../utils/api';
import moment from 'moment'
import CookieConsentComponent from '../../Components/CookieConsent'
import Comparativo from '../Home/comparativo'
import { connect } from 'react-redux'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { Link } from 'react-router-dom'
import fundos1 from '../../images/fundos1.svg'
import fundos2 from '../../images/fundos2.svg'
import fundos3 from '../../images/fundos3.svg'

import './servicos.css'

class Produtos extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
          height: '300px',
          heightSpirit: '300px',
          class: '',
          classSpirit: '',
          visible: false,
          visibleSpirit: false,
          rent0w: '',
          rentSpirit: '',
          chartData: '',
          chartSpirit: ''
        };
    }

    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
        if(window.innerWidth <= 1024){
            this.setState({
                height: '400px',
                heightSpirit: '400px'
            })
        }
        if(window.innerWidth <= 767){
            this.setState({
                height: '400px',
                heightSpirit: '420px'
            })
        }
        
        try {
            const response = await request('operacional/getRentChart', 'GET')
            if (response.code === 12) {
                this.setState({
                    rentSpirit: response.dataS
                }, () => {
                    this.calculateChart()
                })
            } 
        } catch(e) {
            // console.log(e)
            // message.error('Não foi possível registrar a operação')
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    toggleAccordion(e) {
        let id = e.currentTarget.id
        let height
        let height2
        let heightM
        if(window.innerWidth <= 767){
            height = '400px'
            height2 = '500px'
            heightM = 'auto'
        } else if(window.innerWidth <= 1024){
            height = '400px'
            height2 = '400px'
        } else{
            height = '263px'
            height2 = '300px'
        }
        
        if(id === 'asa') {
            if(this.state.class === '' || this.state.class === 'rotate-back'){
                this.setState({
                    class: 'rotate',
                    height: heightM,
                    visible: true,

                })
            } else {
                this.setState({
                    class: 'rotate-back',
                    height: height,
                    visible: false,

                })
            }
        } else {
            if(this.state.classSpirit === '' || this.state.classSpirit === 'rotate-back'){
                this.setState({
                    classSpirit: 'rotate',
                    heightSpirit: heightM,
                    visibleSpirit: true,

                })
            } else {
                this.setState({
                    classSpirit: 'rotate-back',
                    heightSpirit: height2,
                    visibleSpirit: false,

                })
            }
        }
    }

    calculateChart() {
        let labels = []
        let rend01 = []
        let rend02 = []
        let rend03 =[]
        let rend0w = []

        var past_date = new Date('01/01/2019');
        var current_date = new Date();
                                
        var difference = (current_date.getFullYear()*12 + current_date.getMonth()) - (past_date.getFullYear()*12 + past_date.getMonth());
                
        for(let i = 0; i < difference; i++) {
            if(i === 0) {
                labels.push("Jan/2019")
            } else {
                var dt_helper = moment('2019-01-01')
                var dt_somada = moment(dt_helper).add(i, 'M')
                
                labels.push(dt_somada.format('MMM')+"/"+dt_somada.format('Y'))
            }
            rend01.push(0.5)
            rend02.push(0.6)
            rend03.push(0.83)
            rend0w.push(1.15)
        }

        var past_date_spirit = new Date('12/01/2019');
        var current_date = new Date();
                                
        var difference = (current_date.getFullYear()*12 + current_date.getMonth()) - (past_date_spirit.getFullYear()*12 + past_date_spirit.getMonth());

        let rendSpirit = []
        let labelsSpirit = []
        let aux = 0
        for(let i = 0; i < difference; i++) {
            aux = aux + (parseFloat(this.state.rentSpirit[i])/2)
            if(i === 0) {
                labelsSpirit.push("Dez/2019")
            } else {
                var dt_helper = moment('2019-12-01')
                var dt_somada = moment(dt_helper).add(i, 'M')
                
                labelsSpirit.push(dt_somada.format('MMM')+"/"+dt_somada.format('Y'))
            }
            rendSpirit.push(aux)
        }
        let newDataSpirit = {
            labels: labelsSpirit,
                datasets: [
                    {
                    label: 'Flow Digital Assets Spirit',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(130, 130, 130, 1)',
                    borderColor: 'rgba(130, 130, 130, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(130, 130, 130, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 8,
                    pointHoverRadius: 8,
                    pointHoverBackgroundColor: 'rgba(130, 130, 130, 1)',
                    pointHoverBorderColor: 'rgba(130, 130, 130, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 8,
                    data: rendSpirit
                    }
                ]
        }
        let newData = {
            labels: labels,
                datasets: [
                    {
                    label: 'Flow Digital Assets ASA | 4 meses',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(219, 86, 224, 1)',
                    borderColor: 'rgba(219, 86, 224, 1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(219, 86, 224, 1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 8,
                    pointHoverRadius: 8,
                    pointHoverBackgroundColor: 'rgba(219, 86, 224, 1)',
                    pointHoverBorderColor: 'rgba(219, 86, 224, 1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 8,
                    data: rend01
                    }, {
                        label: 'Flow Digital Assets ASA | 8 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(215, 209, 236, 1)',
                        borderColor: 'rgba(215, 209, 236, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(215, 209, 236, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend02
                    }, {
                        label: 'Flow Digital Assets ASA | 10 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(215, 209, 236, 1)',
                        borderColor: 'rgba(215, 209, 236, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(215, 209, 236, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderColor: 'rgba(215, 209, 236, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend03
                    },
                    {
                        label: 'Flow Digital Assets ASA | 12 meses',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'rgba(128, 33, 126, 1)',
                        borderColor: 'rgba(128, 33, 126, 1)',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'rgba(128, 33, 126, 1)',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 8,
                        pointHoverRadius: 8,
                        pointHoverBackgroundColor: 'rgba(128, 33, 126, 1)',
                        pointHoverBorderColor: 'rgba(128, 33, 126, 1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 8,
                        data: rend0w
                    }
                ]
        }
        this.setState({
            chartData: newData,
            chartSpirit: newDataSpirit
        })
    }

    render() {
        const { logged, userLogged, isLoading } = this.props
        return (
            <div id="produtoSection">
                <Navbar fillBackground={this.state.fillBackground} />
                {!logged ? <Redirect to="/" /> : !isLoading && userLogged.nivelVerificacao !== '111' ? <Redirect to="/" /> : (
                    <>
                    <div className="section investimentosHeader headerWrapper">
                        <Container className="h-100">
                            <Row className="h-100">
                                <Col md={6} className="d-flex justify-content-center flex-column">
                                    <h2 className="pageCall text-left">Veículos de investimentos privados de <span className="tx-pink">alta performance</span></h2>
                                    <Link className='anchorBtn mt-5' to="/contratos">Invista agora</Link>
                                </Col>
                                <Col md={6} className="pl-5">
                                    <div className="wrapperInfosFundos">
                                        <div className="blur"></div>
                                        <>
                                        <div className="d-flex align-items-center">
                                            <img src={fundos1} />
                                            <p className="text-white pl-3 mb-0">Supere o risco sem exposição à volatilidade.</p>
                                        </div>
                                        <div className="d-flex align-items-center mt-4 mb-4">
                                            <p className="text-white pr-3 mb-0">Equipe experiente, com capital intelectual altamente qualificado, atuando no setor desde 2015.</p>
                                            <img src={fundos2} />
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <img src={fundos3} />
                                            <p className="text-white pl-3 mb-0">Atendimento personalizado e individual, sem robôs ou filas.</p>
                                        </div>
                                        </>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Container>
                        <Col className="p-0" md={12}>
                            <hr className='divisor' />
                        </Col>
                    </Container>
                    <div className="section insideSec">
                        <Container className="h-100">
                            <Row className="h-100">
                            
                            <Col md={12}>
                                    <div className="produtoCard" style={{height: this.state.heightSpirit, display: 'block', clear: 'both', transitionDuration: '1s', overflow: 'hidden'}}>
                                        <div className="wrapperHelper" id="spirit" onClick={((e) => this.toggleAccordion(e))}>
                                            <h6 className="preTitle tx-pink">Investimento</h6>
                                            <h3 className="text-white cardTitle">Flow Digital Assets Spirit<FontAwesomeIcon id="spirit" icon={faPlay} className={`tx-pink iconSmall ${this.state.classSpirit}`} /></h3>
                                            <hr />
                                            <label className="labelCard text-white"><span className="tx-pink">Tipo: </span>Multimercados&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span className="tx-pink">Valor mínimo: </span>R$20.000,00</label>
                                            <label className="labelCard text-white mt-3"><span className="tx-pink">Resgate: </span>D+45 corridos após solicitação&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span className="tx-pink">Escala de Risco Flow.in: </span>Alto</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Tipo: </span>Multimercados</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Valor mínimo: </span>R$20.000,00</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Resgate: </span>D+45 corridos após aprovação.</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Escala de Risco Flow.in: </span>Nível 4 - Alto</label>
                                            <button id="spirit" onClick={((e) => this.toggleAccordion(e))} className="btnContratarFundo btnContratarMobile anchorBtn">Ver informações</button>
                                        </div>
                                        <Spirit />
                                    </div>
                                </Col>
                            <Col md={12} className="mt-5">
                                    <div className="produtoCard" style={{height: this.state.height, display: 'block', clear: 'both', transitionDuration: '2s', overflow: 'hidden'}}>
                                        <div className="wrapperHelper" id="asa" onClick={((e) => this.toggleAccordion(e))}>
                                            <h6 className="preTitle tx-pink">Investimento</h6>
                                            <h3 className="text-white cardTitle">Flow Digital Assets ASA<FontAwesomeIcon icon={faPlay} className={`tx-pink iconSmall ${this.state.class}`} /></h3>
                                            <hr />
                                            <label className="labelCard text-white"><span className="tx-pink">Tipo: </span>Multimercados&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span className="tx-pink">Valor mínimo: </span>R$500,00</label>
                                            <label className="labelCard text-white mt-3"><span className="tx-pink">Resgate: </span>D+45 corridos após vencimento&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span className="tx-pink">Escala de Risco Flow.in: </span>Baixo</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Tipo: </span>Multimercados</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Valor mínimo: </span>R$2.000,00</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Resgate: </span>D+45 após finalização.</label>
                                            <label className="mobileLabel text-white"><span className="tx-pink">Escala de Risco Flow.in: </span>Nível 2 - Baixo</label>
                                            <button id="asa" onClick={((e) => this.toggleAccordion(e))} className="btnContratarFundo btnContratarMobile anchorBtn">Ver informações</button>
                                        </div>
                                        <Asa />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Comparativo />
                </>
            )}
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
    isLoading: state.users.isLoading
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Produtos)